<div
  class="credit-card"
  [ngClass]="{
    'master-card': CreditCardType.MasterCard === currentCreditCardType,
    visa: CreditCardType.Visa === currentCreditCardType,
    Amex: CreditCardType.Amex === currentCreditCardType
  }"
>
  <div class="credit-card-header">
    <div class="credit-card-mark"></div>

    <div class="credit-card-icon">
      <img *ngIf="CreditCardType.Visa === currentCreditCardType" src="/assets/images/visa-logo.svg" alt="visa-logo" />
      <img
        *ngIf="CreditCardType.MasterCard === currentCreditCardType"
        src="/assets/images/mastercard-logo.svg"
        alt="mastercard-logo"
      />
      <div *ngIf="CreditCardType.Amex === currentCreditCardType" class="amex-logo">AMERICAN EXPRESS</div>
    </div>
  </div>

  <span class="credit-card-number" *ngIf="currentCreditCardNumber">{{ currentCreditCardNumber | mask: creditCardMask }}</span>
  <span class="credit-card-number gray" *ngIf="!currentCreditCardNumber">**** **** **** ****</span>

  <div class="credit-card-footer" [ngClass]="{ active: currentCreditCardNumber }">
    <div class="title">Mes / Año</div>
    <div *ngIf="!dividedDate" class="year">** / **</div>
    <div *ngIf="dividedDate" class="year">{{ dividedDate }}</div>
  </div>
</div>
